import { bool, string } from "prop-types";
import { useMemo } from "react";

import styled from "styled-components";

import FnrTypography from "FnrTypography";

import FnrHorizontalGap from "UI/commonContainers/FnrHorizontalGap";
import FnrVerticalGap from "UI/commonContainers/FnrVerticalGap";

const SFnrVerticalGap = styled(FnrVerticalGap)`
  max-width: ${({ $maxWidth }) => $maxWidth};
  opacity: 0.8;
`;

const FnrLuke15 = ({ isDark, maxWidth = "180px" }) => {
  const fontColor = useMemo(() => {
    if (isDark) return "textLight";
    return "brandFnBlue";
  }, [isDark]);

  return (
    <SFnrVerticalGap
      $maxWidth={maxWidth}
      flexGrow={1}
      data-cy="FnrLuke15_Container"
    >
      <FnrTypography
        color={fontColor}
        type="subheader"
        bold
        italic
        fontSize="xl"
        lineHeight={1.2}
      >
        Go after the one which is lost.
      </FnrTypography>
      <FnrHorizontalGap fullWidth reverse>
        <FnrTypography fontSize="lg" color={fontColor} type="copy">
          - LUKE 15
        </FnrTypography>
      </FnrHorizontalGap>
    </SFnrVerticalGap>
  );
};

FnrLuke15.propTypes = { isDark: bool, maxWidth: string };

export default FnrLuke15;
